import React from "react";
import { CollapsePanel } from "./CollapsePanel";

export const AccumulatorDetails = ({ biInfo, noMoopProvided }) => {
  const productBenefits = biInfo?.productBenefits;
  if (!productBenefits?.length) return null;

  return (
    <CollapsePanel labelText="Accumulator Details">
      {productBenefits.map((benefit, index) => {
        const accumulatorDetail = benefit?.in_net_and_out_net_accumulator_values;
        if (!accumulatorDetail) return null;

        const productTitle = getProductNameWithCodes(benefit.products);

        return (
          <div key={index} className="mb-4">
            <div className="table-responsive p-0">
              <table className="table table-borderless rounded mb-0">
                <thead>
                  <tr>
                    <th className="text-muted fw-semibold fs-5 col-6 pb-2 p-0" id={`product${index + 1}-${productTitle}`}>
                      {productTitle}
                    </th>
                    <th className="text-muted fw-semibold fs-5 text-end pb-2 p-0">IN Network</th>
                    <th className="text-muted fw-semibold fs-5 text-end pb-2 p-0">Out of Network</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Deductible Remaining</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_deductible_remaining`}>
                      {accumulatorDetail.in_net_deductible_remaining}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_deductible_remaining`}>
                      {accumulatorDetail.out_net_deductible_remaining}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Deductible Total</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_deductible_total`}>
                      {accumulatorDetail.in_net_deductible_total}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_deductible_total`}>
                      {accumulatorDetail.out_net_deductible_total}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Max out of Pocket Remaining</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_max_out_of_pocket_remaining`}>
                      {noMoopProvided || accumulatorDetail.in_net_max_out_of_pocket_remaining == null
                        ? "NA"
                        : accumulatorDetail.in_net_max_out_of_pocket_remaining}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_max_out_of_pocket_remaining`}>
                      {accumulatorDetail.out_net_max_out_of_pocket_remaining}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Max out of Pocket Total</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_max_out_of_pocket_total`}>
                      {accumulatorDetail.in_net_max_out_of_pocket_total}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_max_out_of_pocket_total`}>
                      {accumulatorDetail.out_net_max_out_of_pocket_total}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Coinsurance</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_coinsurance`}>
                      {accumulatorDetail.in_net_coinsurance}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_coinsurance`}>
                      {accumulatorDetail.out_net_coinsurance}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Copay</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_copay`}>
                      {accumulatorDetail.in_net_copay}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_copay`}>
                      {accumulatorDetail.out_net_copay}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </CollapsePanel>
  );
};

/**
 * Returns a pipe-delimited string of product names and procedure codes.
 */
const getProductNameWithCodes = (products = []) =>
  products
    .map((product) => (product?.procedureCodes || []).map(({ code }) => `${product.productName} (${code})`))
    .flat()
    .join(" | ");
